import { IStoredTranscription, TranscriptionStorageType } from '../interfaces/IStoredTranscription'
import { ITranscriptionSourceFileProvider } from '../interfaces/ITranscriptionSourceFileProvider';
import { IAuthenticationProvider } from '../interfaces/IAuthenticationProvider';
import { OneDriveTranscriptionSourceFileProvider } from '../oneDrive/OneDriveTranscriptionSourceFileProvider';

export function CreateTranscriptionSourceFileProvider(storedTranscription: IStoredTranscription, authProvider: IAuthenticationProvider): ITranscriptionSourceFileProvider {
    switch (storedTranscription.storageType) {
        case TranscriptionStorageType.DocumentStorage:
        case TranscriptionStorageType.DocumentXmlStorage:
            return new OneDriveTranscriptionSourceFileProvider(storedTranscription.descriptor, authProvider);
        default:
            throw new Error('Unsupported transcription storage source file type: ' + storedTranscription.storageType);
    }
}